// import { generateId } from '@/utils';

import COLORS from './colors.data';
import { Voronoi } from './voronoi';

export function rgb2hsv(r, g, b) {
  let v = Math.max(r, g, b),
    c = v - Math.min(r, g, b);
  let h =
    c &&
    (v == r
      ? (g - b) / c
      : v == g
        ? 2 + (b - r) / c
        : 4 + (r - g) / c);
  return [60 * (h < 0 ? h + 6 : h), v && c / v, v];
}

export function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
}
export function rgbToHex(r, g, b) {
  return (
    '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
  );
}

export function getColorData(radius) {
  let cx = radius;
  let cy = radius;

  let colorsBySite = {};
  let sites = [];

  Object.entries(COLORS).forEach(([name, color]) => {
    let [r, g, b] = color;
    let [h, s, v] = rgb2hsv(r / 255, g / 255, b / 255);

    // Based on https://stackoverflow.com/a/54522007/91238 .
    // I've tweaked it to spread out some of the colors
    // (especially they greys) that don't fit well into a
    // true H/S wheel.
    let colorRadius = (s + v / 5) * 0.75 * radius;
    let colorAngle = (h / 360) * 2 * Math.PI;

    let x = Math.cos(colorAngle) * colorRadius + cx;
    let y = Math.sin(colorAngle) * colorRadius + cy;
    sites.push({ x: x, y: y });
    colorsBySite[[x, y]] = name;
  });

  let voronoi = new Voronoi().compute(sites, {
    xl: 0,
    xr: 1024,
    yt: 0,
    yb: 1024,
  });

  let data = voronoi.cells.map((cell) => {
    if (cell.closeMe) {
      console.warn('cell', cell, 'needs closing');
      return;
    }

    let colorName = colorsBySite[[cell.site.x, cell.site.y]];
    let [r, g, b] = COLORS[colorName];

    let points = '';
    cell.halfedges.forEach((edge) => {
      let s = edge.getStartpoint();
      points += `${s.x} ${s.y}, `;
    });

    // Trim away final comma
    points = points.replace(/, $/, '');

    return {
      colorName,
      rgb: `rgb(${r} ${g} ${b})`,
      points,
    };
  });

  return data.filter((item) => !!item);
}
